/* tslint:disable */
/* eslint-disable */
/**
 * My App
 * This is an awesome app!
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTodoParameters
 */
export interface UpdateTodoParameters {
    /**
     * 
     * @type {string}
     * @memberof UpdateTodoParameters
     */
    content?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTodoParameters
     */
    isDone?: boolean | null;
}

/**
 * Check if a given object implements the UpdateTodoParameters interface.
 */
export function instanceOfUpdateTodoParameters(value: object): value is UpdateTodoParameters {
    return true;
}

export function UpdateTodoParametersFromJSON(json: any): UpdateTodoParameters {
    return UpdateTodoParametersFromJSONTyped(json, false);
}

export function UpdateTodoParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTodoParameters {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'] == null ? undefined : json['content'],
        'isDone': json['isDone'] == null ? undefined : json['isDone'],
    };
}

export function UpdateTodoParametersToJSON(json: any): UpdateTodoParameters {
    return UpdateTodoParametersToJSONTyped(json, false);
}

export function UpdateTodoParametersToJSONTyped(value?: UpdateTodoParameters | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'isDone': value['isDone'],
    };
}

